// src/modules/app-views/omnichannel/config.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { PiChats } from 'react-icons/pi';
import { VscDashboard } from 'react-icons/vsc';
import OmnichannelInit from './pages/Init';
import OmnichannelParametersModal from './pages/Init/modals/OmnichannelParametersModal';
import omnichannelInitMenuButton from './pages/Init/actions/menuButton';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const MODULE_ID = 'omnichannel';

// *******************************************************************************
// PRE CONFIG
// *******************************************************************************
const preConfigChanges = appId => {
  CONFIG.appId = appId;
};

// *******************************************************************************
// MODULE CONFIGURATION
// *******************************************************************************
const CONFIG = {
  version: 2,
  id: MODULE_ID,
  initialPage: 'init',
  initialParams: {},
  initialQuery: {},
  parametersModalComponent: OmnichannelParametersModal,
  parametersSeed: null,
};

// *******************************************************************************
// MODULE PAGES
// *******************************************************************************
const PAGES = {
  // ═══════════════════════════════════════════════════════════════════════════════
  // INIT PAGE - Chat list (empty state)
  // ═══════════════════════════════════════════════════════════════════════════════
  init: {
    // ─────────────────────────────────────────────────────────────────────────
    // PAGE CORE
    // ─────────────────────────────────────────────────────────────────────────
    layout: 'page',
    moduleId: MODULE_ID,
    component: props => <OmnichannelInit />,

    // ─────────────────────────────────────────────────────────────────────────
    // TOUR
    // ─────────────────────────────────────────────────────────────────────────
    tour: {
      firstModal: null,
      lastModal: null,
      onFinish: null,
      triggerConfettiOnFinish: false,
      videoLink: { br: null, us: null },
    },

    // ─────────────────────────────────────────────────────────────────────────
    // API & DATA
    // ─────────────────────────────────────────────────────────────────────────
    api: {
      url: null,
      params: null,
      query: null,
      returnAsObject: false,
      autoFetch: false,
      fetchWithoutSubscription: false,
      removeSubscriptionIdFromHeader: false,
      persistInStore: false,
    },

    // ─────────────────────────────────────────────────────────────────────────
    // DECORATORS
    // ─────────────────────────────────────────────────────────────────────────
    decorators: {
      request: null,
      response: null,
    },

    // ─────────────────────────────────────────────────────────────────────────
    // ROUTING & NAVIGATION
    // ─────────────────────────────────────────────────────────────────────────
    routing: {
      endpoint: '/:_id?',
      paramKey: null,
      query: null,
    },

    // ─────────────────────────────────────────────────────────────────────────
    // LIST / TABLE (not used)
    // ─────────────────────────────────────────────────────────────────────────
    pagination: null,
    table: null,

    // ─────────────────────────────────────────────────────────────────────────
    // DOCUMENT PROVIDER SETTINGS
    // ─────────────────────────────────────────────────────────────────────────
    settings: {},

    // ─────────────────────────────────────────────────────────────────────────
    // HEADER CONFIGURATION
    // ─────────────────────────────────────────────────────────────────────────
    header: {
      visible: true,
      style: 'default',
      forceShowHome: true,
      actions: [omnichannelInitMenuButton],

      viewSelector: [
        { value: 'init', icon: <PiChats size={18} />, tooltip: 'main' },
        { value: 'dashboard', icon: <VscDashboard size={18} />, tooltip: 'dashboard' },
      ],

      navigation: {
        showTitle: true,
        showBreadcrumb: true,
        customBreadcrumb: () => ['operational', 'omnichannel'],
      },
    },
  },
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default { CONFIG, PAGES, preConfigChanges };
